import React from "react";
import { Spinner, Stack, Text } from "@chakra-ui/react";

export const Loading = () => {
  return (
    <Stack isInline={true} spacing={2} p={2}>
      <Spinner size="md" thickness="3px" />
      <Text as="em">Loading...</Text>
    </Stack>
  );
};
